'use client';

import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { useFooter } from '@/features/footer/api/query/use-footer';
import { useLogoUrl } from '@/hooks/use-logo-url';
import { useBreakpointUp } from '@/hooks/use-theme';
import { Phone } from '@phosphor-icons/react/dist/ssr';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import { type ReactNode, useEffect } from 'react';

interface Props {
  backButton?: ReactNode;
}

export const NavigationSimplified = ({ backButton }: Props) => {
  const t = useTranslations('common');
  const logoUrl = useLogoUrl();
  const isDesktop = useBreakpointUp('s');
  const locale = useLocale();
  const mainPath = locale === 'ru-ee' || locale === 'ru-lv' ? '/ru' : '/';

  const { data } = useFooter();

  const phoneNumber = data?.contactInfo?.phones?.[0]?.title ?? '';

  useEffect(() => {
    document.body.classList.remove('sticky');
  }, []);

  return (
    <div className="flex min-h-xl s:min-h-[72px] border-t-6 border-t-brand border-b-1 border-b-decorative">
      <div className="container relative flex h-full max-w-full items-center justify-between">
        <div className="flex flex-1 items-center justify-start">
          {backButton}
        </div>

        <div className="flex w-max flex-1 items-center justify-center">
          <Button
            variant="tertiary-no-frame"
            size={isDesktop ? 'large' : 'default'}
            aria-label="Logo"
            className="flex items-center"
            href={mainPath}
            isLink
          >
            <Image
              src={logoUrl}
              alt="Logo"
              priority
              className="h-[32px] s:h-clickable"
              width={108}
              height={48}
            />
          </Button>
        </div>

        <div className="flex flex-1 items-center justify-end">
          <Button
            isLink
            aria-label={t('company.phone')}
            href={`tel:${phoneNumber}`}
            variant="tertiary-no-frame"
            size={isDesktop ? 'large' : 'default'}
            className="!font-normal flex h-full items-center gap-xxs"
          >
            <PhosphorIcon Icon={Phone} className="icon-m s:icon-l m:icon-m" />
            <span className="m:inline hidden">{phoneNumber}</span>
          </Button>
          {/*// TODO Fix in future*/}
          {/*<Button*/}
          {/*  variant="tertiary-no-frame"*/}
          {/*  size={isDesktop ? 'large' : 'default'}*/}
          {/*  className="flex h-full items-center gap-xxs"*/}
          {/*>*/}
          {/*  <PhosphorIcon*/}
          {/*    Icon={ChatCenteredText}*/}
          {/*    className="icon-m s:icon-l m:icon-m"*/}
          {/*  />*/}
          {/*  <span className="hidden font-normal m:inline">*/}
          {/*    {t('navigation.chat')}*/}
          {/*  </span>*/}
          {/*</Button>*/}
        </div>
      </div>
    </div>
  );
};
